export default __webpack_public_path__ + "logo0369f5ed.png";